import { useMemo } from 'react'

import { Typography } from '@mui/material'
import { MediaPlatform } from '@nativewaves/nw-cloud-sdk/media'
import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { CopyId } from '@shared/components/Table/Fields'

export const useColumns = () => {
  const { t } = useTranslation(['common', 'domain'])

  return useMemo<ColumnDef<MediaPlatform>[]>(
    () => [
      {
        accessorKey: 'name',
        header: t('name'),
        meta: {
          sizing: {
            minWidth: 300,
            px: 2,
          },
        },
        cell: ({ getValue }) => (
          <Typography variant="inherit" noWrap>
            {getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'id',
        header: t('id'),
        meta: {
          sizing: {
            width: 200,
            px: 2,
          },
        },
        cell: ({ getValue }) => <CopyId id={getValue<string>()} />,
      },
    ],
    [t],
  )
}
